import React, { ReactElement } from 'react';
import styles, { getChatGroupStyles } from './chatGroup.style';
import Tooltip from '@vromo/ui/components/Tooltip';
import ProfileImage from '@vromo/ui/components/ProfileImage';
import { format } from 'date-fns';
import { ChatHistoryItem } from '../../../../helpers/JobHistoryHelper';

interface Props {
    chatGroup: ChatHistoryItem[];
    dashboardUserIds: number[];
}

const ChatGroup = ({ chatGroup, dashboardUserIds }: Props): ReactElement => {
    const isDashboardUser = dashboardUserIds.includes(chatGroup[0]?.fromUser.id || 0);
    const user = chatGroup[0]?.fromUser;
    const dynamicStyles = getChatGroupStyles(isDashboardUser);
    const tooltipLabel = user?.contact?.name || user?.contact?.email || 'Unknown';

    const formatDate = (messageDate: Date) =>
        `${format(messageDate, 'MMMM Do, YYYY')} at ${format(messageDate, 'hh:mm A')}`;

    return (
        <div key={chatGroup[0]?.created} style={dynamicStyles.containerStyles}>
            <div style={styles.groupContent}>
                <Tooltip position="bottom" label={tooltipLabel}>
                    <div style={dynamicStyles.imageStyles}>
                        <ProfileImage url={user?.avatar?.url} user={user} size={32} />
                    </div>
                </Tooltip>
                <div style={dynamicStyles.messagesContainer}>
                    {chatGroup.map((chat: ChatHistoryItem) => {
                        const { created, message } = chat;
                        const messageTooltipLabel = formatDate(new Date(created));

                        return (
                            <Tooltip key={created} position="bottom" label={messageTooltipLabel}>
                                <div style={styles.messageBubble}>
                                    <p style={styles.messageText}>{message}</p>
                                </div>
                            </Tooltip>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ChatGroup;
